const PageHeader = ({
  eyebrow,
  title,
  description,
  action,
  className = "",
}) => (
  <div className={`mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between ${className}`}>
    <div className="min-w-0">
      {eyebrow && (
        <p className="mb-1 text-xs font-semibold uppercase tracking-wider text-[#0BBF64]">
          {eyebrow}
        </p>
      )}
      <h1 className="text-xl sm:text-2xl font-extrabold tracking-tight text-slate-900">
        {title}
      </h1>
      {description && (
        <p className="mt-1.5 text-sm leading-relaxed text-slate-600">
          {description}
        </p>
      )}
    </div>
    {action && <div className="shrink-0">{action}</div>}
  </div>
);

export default PageHeader;
